import { CommunityHeader } from "./CommunityHeader";
import { CoverImage } from "./CoverImage";
import { Offer } from "./Offer/Offer";
import { Paywall } from "./Paywall";
import { PriceSelector } from "./PriceSelector";

export const CheckoutDescription = Object.assign(Paywall, {
  Offer,
  CoverImage,
  PriceSelector,
  CommunityHeader,
});
